import * as React from "react";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import Modal from "components/Modal";
import {pingLocation} from "geolocation/actions";
import {useEffect, useState} from "react";
declare const navigator: any;

interface IConnectProps {
    userId: number;
    dispatch?: (action: any) => void;
}
function GeoLocation(props: IConnectProps) {
    const [showModal, updateModalStatus] = useState<boolean>(false);
    function attemptGpsPing() {
        updateModalStatus(false);
        navigator.geolocation.getCurrentPosition(handleSuccess);
    }
    function handleSuccess(position) {
        props.dispatch(pingLocation (position.coords.longitude, position.coords.latitude, props.userId));
    }
    function checkLocationPermission() {
        if (navigator && navigator.permissions && navigator.permissions.query) {
            navigator.permissions.query({name: "geolocation"})
                .then((permissionStatus) => {
                    if (permissionStatus.state === "prompt") {
                        updateModalStatus(true);
                    } else if (permissionStatus.state === "granted") {
                        attemptGpsPing();
                    }
                });
        }
    }
    useEffect(() => {
        checkLocationPermission();
    }, []);

    return (
        <Modal
            title  = "Location Permission"
            active = {showModal}
            cancellable = {true}
            cancelTitle = "Deny"
            onClose = {() => updateModalStatus(false)}
            submitTitle = "Accept"
            onSubmit= {attemptGpsPing}
        >
            Please grant access to your location so we can serve you better.
        </Modal>
    );
}
const mapStateToProps = (state: IReduxState): IConnectProps => {
    const auth = state.login.auth ? state.login.auth : null;
    return {
        userId: auth ? auth.userId : null,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(GeoLocation);
